import React from 'react';
import { FileText, Mail, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <section className="bg-[#003d82] text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <FileText size={64} className="mx-auto mb-6 text-[#f5a623]" />
            <h1 className="text-4xl font-bold mb-4">Termos e Condições de Uso</h1>
            <p className="text-xl text-gray-200">
              Informações legais sobre o uso deste website
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-bold text-[#003d82] mb-4">1. Aceitação dos Termos</h2>
              <p className="text-gray-600 mb-8">
                Ao aceder e utilizar o website da Litoral Norte - Transportes Rodoviários de Passageiros, concorda em cumprir e ficar vinculado aos seguintes termos e condições de uso.
              </p>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">2. Uso do Website</h2>
              <p className="text-gray-600 mb-6">
                Este website destina-se a fornecer informações sobre os nossos serviços de transporte. O utilizador compromete-se a:
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-8">
                <li>Utilizar o site apenas para fins lícitos</li>
                <li>Não danificar, desativar ou sobrecarregar o website</li>
                <li>Não tentar aceder a áreas restritas sem autorização</li>
                <li>Fornecer informações verdadeiras nos formulários</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">3. Propriedade Intelectual</h2>
              <p className="text-gray-600 mb-8">
                Todo o conteúdo deste website, incluindo textos, gráficos, logótipos, imagens e software, é propriedade da Litoral Norte ou dos seus fornecedores de conteúdo e está protegido pelas leis de direitos de autor portuguesas e internacionais.
              </p>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">4. Serviços Oferecidos</h2>
              <p className="text-gray-600 mb-6">
                As informações sobre serviços, horários e tarifas apresentadas neste website são indicativas e podem estar sujeitas a alterações. Para informações definitivas, contacte-nos diretamente.
              </p>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">5. Limitação de Responsabilidade</h2>
              <p className="text-gray-600 mb-8">
                A Litoral Norte esforça-se por manter as informações neste website precisas e atualizadas. No entanto, não garantimos a exatidão, completude ou atualidade das informações. O uso das informações é por sua conta e risco.
              </p>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">6. Links Externos</h2>
              <p className="text-gray-600 mb-8">
                Este website pode conter links para sites externos (UNIR, CIM Cávado). Não somos responsáveis pelo conteúdo ou práticas de privacidade desses sites.
              </p>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">7. Alterações aos Termos</h2>
              <p className="text-gray-600 mb-8">
                Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entram em vigor imediatamente após a publicação no website.
              </p>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">8. Lei Aplicável</h2>
              <p className="text-gray-600 mb-8">
                Estes termos são regidos pelas leis de Portugal. Qualquer disputa será resolvida nos tribunais competentes da comarca da Póvoa de Varzim.
              </p>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">9. Contactos</h2>
              <p className="text-gray-600 mb-6">
                Para questões sobre estes termos e condições:
              </p>
              
              <div className="bg-blue-50 border-l-4 border-[#003d82] p-6 rounded-r-lg mb-8">
                <p className="font-semibold text-[#003d82] mb-4">Litoral Norte - Transportes Rodoviários de Passageiros</p>
                <p className="text-gray-700 mb-3">
                  {companyInfo.address.street}<br />
                  {companyInfo.address.lojas}<br />
                  {companyInfo.address.postal} {companyInfo.address.city}
                </p>
                <div className="flex items-center gap-3 mb-3">
                  <Mail className="text-[#003d82]" size={20} />
                  <a href={`mailto:${companyInfo.email}`} className="text-[#003d82] font-semibold hover:text-[#f5a623]">
                    {companyInfo.email}
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="text-[#003d82]" size={20} />
                  <a href={`tel:${companyInfo.phone}`} className="text-[#003d82] font-semibold hover:text-[#f5a623]">
                    {companyInfo.phone}
                  </a>
                </div>
              </div>

              <p className="text-sm text-gray-500 mt-8">
                Última atualização: {new Date().toLocaleDateString('pt-PT', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
